import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'itl-change-amount',
  templateUrl: './change-amount-component.html',
  styleUrls: ['./change-amount-component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChangeAmountComponent),
      multi: true,
    },
  ],
})
export class ChangeAmountComponent {
  @Input() value;
  @Input() selectedPackagingUnit;
  @Input() selectedTimePeriod;
  @Input() header = '';
  @Input() selectionEnabled = true;

  @Output() selectClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() minusClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() plusClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
}
